import { Input as AntdInput } from 'antd'
import type { TextAreaProps as AntdTextAreaProps, InputRef } from 'antd/lib/input'
import { forwardRef } from 'react'
import styles from './styles.module.scss'

export type TextAreaProps = AntdTextAreaProps

export type TextAreaRef = InputRef & {
  resizableTextArea?: {
    textArea?: {
      selectionStart: number
      value: string
      focus: () => void
      setSelectionRange: (start: number, end: number) => void
    }
  }
}

export const TextArea = forwardRef<InputRef, TextAreaProps>(
  ({ className, disabled, showCount, ...props }, ref) => {
    const classNames = [
      className,
      disabled ? 'ant-input-disabled' : '',
      showCount ? styles.fixCountMargin : '',
    ].join(' ')

    return (
      <AntdInput.TextArea
        ref={ref}
        {...props}
        disabled={disabled}
        showCount={showCount}
        className={classNames}
      />
    )
  },
)
TextArea.displayName = 'TextArea'
